import { render, staticRenderFns } from "./recommendReport.vue?vue&type=template&id=059a2cc6&scoped=true"
import script from "./recommendReport.vue?vue&type=script&lang=js"
export * from "./recommendReport.vue?vue&type=script&lang=js"
import style0 from "./recommendReport.vue?vue&type=style&index=0&id=059a2cc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059a2cc6",
  null
  
)

export default component.exports